import type { AnswerType } from '~/model/AnswerType';
import type { ConclusionType } from '~/model/ConclusionType';
import type { UriType } from '~/model/GlobalTypes';
import type { QuestionReconstructedType } from '~/model/QuestionType';
import { apiTypes } from '~/const/api';
import { updateAllAnswers } from './answer';

export function buildQuestionsToDisplay({
  questions,
  conclusions,
  answers,
}: {
  questions: QuestionReconstructedType[];
  conclusions: ConclusionType[];
  answers: AnswerType[];
}) {
  const currentAnswerUser = updateAllAnswers(
    answers,
    null,
    questions,
  ).answerUser;

  let questionsToDisplayTemp: QuestionReconstructedType[] = [];
  let conditionalChoices: UriType[] = [];
  let branchConclusions: UriType[] = [];

  if (questions && questions.length > 0) {
    for (const question of questions) {
      const questionUri = question['@id'];
      const answerUser = currentAnswerUser[questionUri];
      const branchChoiceUri = question.branch_choice;
      const answerUserChoice = answerUser?.answer_choices?.[0];

      const haveToDisplay = conditionalChoices?.includes(branchChoiceUri);

      if (branchChoiceUri && !haveToDisplay)
        continue;

      if (branchConclusions.includes(branchChoiceUri))
        break;

      questionsToDisplayTemp = [...questionsToDisplayTemp, question];

      if (question.type === apiTypes.CONDITIONAL && !answerUser)
        break;

      if (answerUser?.type === apiTypes.CONDITIONAL) {
        conditionalChoices = [...conditionalChoices, answerUserChoice];
      }

      if (branchConclusions.length === 0) {
        const hasAnswerForBranchChoice = conclusions?.some(
          c => c.branch_choice && c.branch_choice['@id'] === answerUserChoice,
        );

        branchConclusions = hasAnswerForBranchChoice ? [answerUserChoice] : [];
      } else if (
        branchConclusions.length > 0
        && branchConclusions.includes(branchChoiceUri)
        && answerUserChoice
      ) {
        branchConclusions = [...branchConclusions, answerUserChoice];
      }
    }
  }

  return questionsToDisplayTemp;
};
